"use client";

import { useEffect } from "react";
import { trackAIAstrologerOpened, trackAstrologerPageViewed } from "@/lib/analytics";

/**
 * Fires astrologer_page_viewed once on mount. Mounted from the
 * /ai-astrologer/page.tsx server component since metadata-bearing
 * pages can't be client components in Next.js.
 */
export default function AstrologerPageTracker({ language = "en" }: { language?: string }) {
  useEffect(() => {
    trackAstrologerPageViewed({
      language,
      source: typeof document !== "undefined" ? document.referrer : undefined,
      source_path: typeof window !== "undefined" ? window.location.pathname : undefined,
    });
    trackAIAstrologerOpened({
      language,
      source: typeof document !== "undefined" ? document.referrer : undefined,
      source_path: typeof window !== "undefined" ? window.location.pathname : undefined,
      placement: "ai_astrologer_page",
    });
  }, [language]);
  return null;
}
